export class Roles {
  public static readonly KST: string = "Publisher KST";
  public static readonly BASIS: string = "Publisher PLOOI";
}
